<template>
  <div v-if="dados">
    <div class="container-produtos-sacola">
      <div v-if="dados.produtos && dados.produtos.length">
        <div :id="`itemPedido${index}`" class="produto-sacola" v-for="(p, index) in dados.produtos" :key="index">
          <div class="mr-2">
            <button class="btn text-danger btn-sm" @click="removeItem(index)" title="Remover da sacola" :disabled="p.id_beneficio"><i class="fas fa-trash-alt"></i></button>
          </div>
          <div class="small pointer" @click="openModalEditar(p)">
            <p class="mb-0">
              <b v-if="p.produto.id_medida === '2'">{{p.quantidade.toFixed(3)}}kg</b>
              <b v-else>{{p.quantidade}}x</b>
              - {{p.produto.nome_produto}} <i class="fa fa-edit text-info ml-1"></i>
            </p>
            <p v-for="d in p.divisoes" class="m-0 pl-1"> # {{d.nome_produto}}</p>
            <p v-for="d in p.adicionais" class="m-0 pl-1">
              + <span v-if="d.qtd > 1">{{d.qtd}}x</span>
              {{d.nome_produto}} <span v-if="d.valor > 0"> <b>{{(d.valor * d.qtd) | valor}}</b></span>
            </p>
            <p class="mb-0" v-show="p.observacao"><b>Obs:</b> {{p.observacao}}</p>
            <span class="badge badge-warning" v-if="p.id_beneficio"><i class="fa fa-trophy mr-1"></i> Benefício</span>
            <p class="mb-0 font-weight-bold" v-else>Total: {{(p.valor * p.quantidade) | valor}}</p>
          </div>
          <div class="ml-auto align-self-center">
            <div class="d-flex justify-content-between align-items-center border rounded-sm" v-if="p.produto.id_medida !== '2'">
              <button class="btn btn-count" @click="minusQtd(p, index)" :disabled="p.id_beneficio">
                <i class="fa fa-minus"></i>
              </button>
              <div class="qtd-output">{{p.quantidade}}</div>
              <button class="btn btn-count text-primary" @click="plusQtd(p)" :disabled="p.id_beneficio">
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center my-5" v-else>
        <div class="py-4 text-primary">
          <icon-pdv name="sacola" size="100"/>
        </div>
        <div class="small mb-3">Sua sacola no momento está vazia.</div>
      </div>
    </div>

    <modal width="tiny" :opened="modalEditar === 1">
      <div class="px-2" v-if="modalEditar && item.produto">
        <div class="border-bottom text-center pb-3 mb-2">
          <h6 class="font-weight-bold mb-0">{{item.produto.nome_produto}}</h6>
        </div>
        <div class="alert alert-warning d-flex align-items-center mb-2" v-if="itemEditar.id_beneficio">
          <i class="fa fa-info-circle mr-2"></i><span class="small">Você pode alterar apenas as observações de um benefício.</span>
        </div>
        <div class="mb-4">
          <label class="small mb-1"><b>Observações</b></label>
          <textarea class="form-control" id="observacoes" rows="3" maxlength="100" placeholder="Observações do produto."
                    style="resize: none" v-model="itemEditar.observacao"></textarea>
        </div>
        <button class="btn btn-success btn-block mb-2" @click="editarItem()">
          Salvar
        </button>
        <button type="button" class="btn text-dark btn-block" @click="closeModalEditar">Cancelar</button>
      </div>
    </modal>
  </div>
</template>

<script>
  import Modal from "@/components/gestor/ModalGestor";
  import Quantidade from "@/components/pedido-manual/Quantidade";
  import IconPdv from "@/components/pedido-manual/IconPdv";

  export default {
    name: 'RevisePedido',
    components: {IconPdv, Quantidade, Modal},
    props: ['dados'],
    data() {
      return {
        modalEditar: null,
        item: {},
        itemEditar: { quantidade: 0, observacao: '' },
      }
    },

    methods: {
      openModalEditar(dados) {
        if (!dados) {
          return;
        }

        this.item = dados;

        if (dados.id_beneficio) {
          this.itemEditar = {
            produto: dados.produto,
            adicionais: dados.adicionais,
            divisoes: dados.divisoes,
            observacao: dados.observacao,
            valor: dados.valor,
            id_beneficio: dados.id_beneficio,
            quantidade: dados.quantidade
          };

          this.modalEditar = 1;
          this.$nextTick(() => {
            this.$helpers.focusElement('observacoes');
          });

        } else {
          this.openProduto();
        }
      },

      closeModalEditar() {
        this.item = {};
        this.itemEditar = { quantidade: 0, observacao: '' };
        this.modalEditar = null;
      },

      editarItem() {
        this.item.observacao = this.itemEditar.observacao;
        this.item.quantidade = this.itemEditar.quantidade;
        this.$emit('atualizar');
        this.closeModalEditar();
      },

      plusQtd(p) {
        p.quantidade++;
        this.$emit('atualizar');
      },

      minusQtd(p, index) {
        if (p.quantidade > 1) {
          p.quantidade--;

        } else {
          this.removeItem(index);
        }

        this.$emit('atualizar');
      },

      removeItem(index) {
        this.$helpers.confirmarSenhaAdm(this, () => {
          this.dados.produtos.splice(index, 1);
          this.$emit('atualizar');
        });
      },

      openProduto() {
        this.$emit('editarProduto', this.item);
        this.closeModalEditar();
      }
    }
  }

</script>
<style scoped>
  .container-produtos-sacola {
    padding: 15px;
  }

  .produto-sacola {
    display: flex;
    padding: 8px 0;
    border-bottom: 1px solid #e9e9e9;
  }

  .produto-sacola:last-child {
    border-bottom: none;
  }

  .qtd-output {
    text-align: center;
    font-weight: bold;
    font-size: 0.9rem;
    width: 28px;
  }

  .btn-count {
    margin: 1px;
    padding: 4px 6px;
  }

  @media (min-width: 768px) {
    .container-produtos-sacola {
      padding: 8px;
      overflow-y: auto;
      font-variant-numeric: tabular-nums;
      height: calc(100vh - 273px);
    }
  }
</style>
